import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45fa2cdd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=45fa2cdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa2cdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45fa2cdd')) {
      api.createRecord('45fa2cdd', component.options)
    } else {
      api.reload('45fa2cdd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=45fa2cdd&scoped=true&", function () {
      api.rerender('45fa2cdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/groupBookingShow/index.vue"
export default component.exports